<style scoped>
.menu-item span{
  display: inline-block;
  width: 80px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width .5s ease .3s;
}
</style>
<template>
  <Submenu :name="`${parentName}`" :class="menuitemClasses">
    <template slot="title">
      <span><common-icon :type="parentItem.icon || ''" />{{ showTitle(parentItem) }}</span>
    </template>
    <template v-for="item in children">
      <template v-if="item.children && item.children.length === 1">
        <side-menu-item v-if="showChildren(item)" :class="menuitemClasses" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
        <menu-item v-else :class="menuitemClasses" :name="getNameOrHref(item, true)" :key="`menu-${item.children[0].name}`">
          <span>
            <common-icon :type="item.children[0].icon || ''"/>&nbsp;
            {{ showTitle(item.children[0]) }}
          </span>
        </menu-item>
      </template>
      <template v-else>
        <side-menu-item v-if="showChildren(item)" :class="menuitemClasses" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
        <menu-item v-else :class="menuitemClasses" :name="getNameOrHref(item)" :key="`menu-${item.name}`">
          <span>
            <common-icon :type="item.icon || ''"/>&nbsp;
            {{ showTitle(item) }}</span>
        </menu-item>
      </template>
    </template>
  </Submenu>
</template>
<script>
import mixin from './mixin'
import itemMixin from './item-mixin'
export default {
  name: 'SideMenuItem',
  mixins: [ mixin, itemMixin ],
  props: ['collapsed'],
  computed: {
    menuitemClasses () {
      return [
        'menu-item',
        this.collapsed ? 'collapsed-menu' : 'menu-item'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/components/side-menu/side-menu-item.vue